// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search_search-container__Y1Rsf {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ant-select-selector,
.ant-select-selection-search-input {
  border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SearchComponents/Search.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,2BAAA;AACF","sourcesContent":[".search-container {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n:global(.ant-select-selector),\n:global(.ant-select-selection-search-input) {\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-container": `Search_search-container__Y1Rsf`
};
export default ___CSS_LOADER_EXPORT___;
